import { Settings, ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface TabletHeaderProps {
  restaurantName: string;
  restaurantLogo: string | null;
  tableNumber: string;
  cartItemCount: number;
  kioskEnabled?: boolean;
  onTableSettingsClick: () => void;
  onCartClick: () => void;
}

export function TabletHeader({
  restaurantName,
  restaurantLogo,
  tableNumber,
  cartItemCount,
  kioskEnabled,
  onTableSettingsClick,
  onCartClick,
}: TabletHeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 bg-slate-900/95 backdrop-blur-sm border-b border-slate-800 px-6 py-4 flex items-center justify-between z-50">
      {/* Logo and restaurant name */}
      <div className="flex items-center gap-4">
        {restaurantLogo && (
          <img
            src={restaurantLogo}
            alt={restaurantName}
            className="w-12 h-12 rounded-full object-cover ring-2 ring-primary/30"
          />
        )}
        <div>
          <h1 className="text-xl font-bold text-white">{restaurantName}</h1>
          <button
            onClick={onTableSettingsClick}
            className="flex items-center gap-1 text-sm text-primary hover:text-primary/80 transition-colors"
          >
            Mesa {tableNumber}
            <Settings className="w-3 h-3" />
            {kioskEnabled ? <span className="ml-1 text-[10px] text-slate-400">(Kiosk)</span> : null}
          </button>
        </div>
      </div>

      {/* Cart button */}
      <Button
        variant="outline"
        size="lg"
        className="relative bg-slate-800 border-slate-700 text-white hover:bg-slate-700"
        onClick={onCartClick}
      >
        <ShoppingCart className="w-5 h-5 mr-2" />
        Carrinho
        {cartItemCount > 0 && (
          <Badge className="absolute -top-2 -right-2 bg-primary text-primary-foreground">
            {cartItemCount}
          </Badge>
        )}
      </Button>
    </header>
  );
}
